import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AppLoaderDirective } from './app-loader.directive';
import { AppLoaderService } from './app-loader.service';
import { AppLoaderFactory } from './app-loader-factory';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [AppLoaderDirective],
  exports: [AppLoaderDirective],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: AppLoaderFactory,
      deps: [AppLoaderService, Router],
      multi: true,
    },
  ],
})
export class AppLoaderModule {}
